import IconTriangleArrowTop from '@dealroadshow/uikit/core/components/Icon/IconTriangleArrowTop';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface IUpsizedDeal {
  deal: IDealHeader,
}

const UpsizedDeal = ({ deal }: IUpsizedDeal) => (
  <div className={ styles.upsizedCol } data-test="dealRowUpsized">
    {
      deal.upsized
      && (
        <Tooltip content="Deal Upsized" wrpClassName={ styles.upsizedTooltip }>
          <IconTriangleArrowTop className={ styles.icon } />
        </Tooltip>
      )
    }
  </div>
);

export default UpsizedDeal;
